import React from "react";
import {
  BarChart, Bar, LineChart, Line,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import { formatCurrency } from "../utils/formatters";
import { CHART_COLORS } from "../constants/defaults";

const tooltipStyle = {
  borderRadius: 10,
  border: "1px solid var(--border)",
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  fontSize: 13,
};

const axisStyle = { fontSize: 11, fill: "var(--gray-400)" };

const LoanCharts = ({ chartData }) => (
  <>
    <div className="chart-section">
      <h2 className="section-heading gradient-title">📊 Payment Breakdown</h2>
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={chartData} margin={{ top: 10, right: 20, left: 10, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--gray-100)" vertical={false} />
            <XAxis dataKey="month" tick={axisStyle} tickLine={false} axisLine={false} />
            <YAxis tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}k`} tick={axisStyle} tickLine={false} axisLine={false} />
            <Tooltip
              formatter={(value) => [formatCurrency(value)]}
              contentStyle={tooltipStyle}
              cursor={{ fill: "rgba(79,70,229,0.04)" }}
            />
            <Legend
              iconType="circle"
              iconSize={8}
              wrapperStyle={{ fontSize: 12, paddingTop: 12 }}
            />
            <Bar dataKey="interest" stackId="a" name="Interest" fill={CHART_COLORS.interest} radius={[0, 0, 0, 0]} />
            <Bar dataKey="principal" stackId="a" name="Principal" fill={CHART_COLORS.principal} />
            <Bar dataKey="extraPayment" stackId="a" name="Monthly Extra" fill={CHART_COLORS.extraPayment} />
            <Bar dataKey="lumpsumPrepayment" stackId="a" name="Lumpsum" fill={CHART_COLORS.lumpsum} radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>

    <div className="chart-section">
      <h2 className="section-heading gradient-title">📉 Outstanding Balance</h2>
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={chartData} margin={{ top: 10, right: 20, left: 10, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--gray-100)" vertical={false} />
            <XAxis
              dataKey="month"
              tick={axisStyle}
              tickLine={false}
              axisLine={false}
              label={{ value: "Month", position: "insideBottom", offset: -12, fontSize: 11, fill: "var(--gray-400)" }}
            />
            <YAxis
              tickFormatter={(v) => `₹${(v / 1000).toFixed(0)}k`}
              tick={axisStyle}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip
              formatter={(value) => [formatCurrency(value), "Balance"]}
              contentStyle={tooltipStyle}
              cursor={{ stroke: "var(--primary-light)", strokeDasharray: "4 4" }}
            />
            <Line
              type="monotone"
              dataKey="balance"
              name="Outstanding Balance"
              stroke={CHART_COLORS.balance}
              strokeWidth={2.5}
              dot={false}
              activeDot={{ r: 5, strokeWidth: 0, fill: CHART_COLORS.balance }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  </>
);

export default LoanCharts;
